<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Trigger from '../../Models/Trigger';
	import Validation from './Password/Validation.svelte';

	export let index = 0;

	let slide = {};
	let active = false;

	async function deleteUser() {
		if (Helper.onlineNotice()) {
			const config = Config.labels.delete_user;
			const response = await API.deleteUser();
			if (response.success) {
				const message = config.success;
				Trigger.event('alert', {icon: 'user-check', message});

				API.signOut();
				Slider.route('start');
			}

			else {
				const message = config.error;
				Trigger.event('alert', {icon: 'user-minus', message});
			}
		}
	}

	function updateSlider(slides) {
		slide = slides[`slide_${index}`].properties;
		active = slide.active;
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	h2.warning {
		color: var(--error-color) !important;
	}

	a.button.proceed {
		text-align: left;
	}

	div.panel {
		display: flex;
		justify-content: space-between;
		margin-bottom: 3em;
	}

	div.panel .button {
		margin-bottom: 0;
	}

	div.content div.warning {
		padding: .5em 1.5em 1em 1.5em;
		border: 1px solid rgba(0, 0, 0, .1);
		border-radius: .5em;
		background-color: var(--box-background);
	}

	:global(html.dark div.profile div.content div.warning) {
		border-color: rgba(255, 255, 255, .1) !important;
		background-color: rgba(255, 255, 255, .05) !important;
	}

	:global(html.dark div.profile div.content div.warning h2.warning) {
		color: var(--primary-color) !important;
	}

	@media (max-device-width: 1024px) {
		div.panel {
			flex-direction: column;
		}

		div.panel .button,
		div.panel input,
		div.panel div.group {
			width: 100% !important;
			margin-bottom: .5em;
		}

		div.panel .button {
			padding-top: 1em;
			padding-bottom: 1em;
		}
	}
</style>

<div class="box authentication profile feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Profiel</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		{#if $API.active && $Session.authentication.active}
			<h1>{$Session.user.name}</h1>
			<p>Hier vind je de mogelijkheid om jouw account te verwijderen.</p>
			<div class="warning">
				<h2 class="duck warning">Wil je jouw account verwijderen?</h2>
				<p>Weet je zeker dat je jouw account wilt verwijderen? Kies dan hieronder voor "Account Verwijderen". We zullen dan al jouw gegevens uit onze database verwijderen. Let op: dit kan later niet ongedaan worden gemaakt.</p>
				<div class="button error solid" on:click="{event => deleteUser()}">
					<i class="fad fa-user-times"></i> Account Verwijderen
				</div>
			</div>
		{/if}
	</div>
</div>